import { Component, HostBinding, Input, OnInit } from '@angular/core';

type CURRENCY_LENGTH = 'short' | 'long' | 'decimal';

@Component({
  selector: 'fl-currency',
  template: `
    <ng-container *ngIf="length === 'long'">{{ value | currency:code:false:'1.2-2' }}</ng-container>
    <ng-container *ngIf="length === 'short'">{{ value | currency:code:true:'1.2-2' }}</ng-container>
    <ng-container *ngIf="length === 'decimal'">{{ value | number:'1.2-2' }}</ng-container>
  `,
})
export class CurrencyComponent implements OnInit {
  @HostBinding('attr.code')
  @Input()
  code: string;
  @HostBinding('attr.value')
  @Input()
  value: number;
  @HostBinding('attr.length')
  @Input()
  length: CURRENCY_LENGTH = 'long';

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/app/@shared/ui/currency.component.ts